import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import AboutPage from "../pages/AboutPage";
import NotFoundPage from "../pages/NotFoundPage";
import SettingsPage from "../pages/SettingsPage";
import InfoPage from "../pages/InfoPage";
import AdminPage from "../pages/AdminPage";
import DevicesPage from "../pages/DevicesPage";
import ChallengeDashboard from "../pages/ChallengeDashboard";
import AnalyticsPage from "../pages/AnalyticsPage";
import FriendsPage from "../pages/FriendsPage";

const ChallengeWrapper = () => {
  const { challengeId } = useParams();
  return <ChallengeDashboard challengeId={challengeId} />;
};

const AppRoutes = () => {
  return (
    <section>
      <Routes>
        {/* Step Challenge Platform Routes */}
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/challenges" element={<ChallengeDashboard />} />
        <Route path="/challenges/create" element={<ChallengeDashboard />} />
        <Route path="/challenges/:challengeId" element={<ChallengeWrapper />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/friends" element={<FriendsPage />} />
        
        {/* Account Management Routes */}
        <Route path="/my-account/settings" element={<SettingsPage />} />
        <Route path="/my-account/info" element={<InfoPage />} />
        <Route path="/my-account/admin" element={<AdminPage />} />
        
        {/* Static Pages */}
        <Route path="/about" element={<AboutPage />} />
        
        {/* 404 Page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </section>
  );
};

export default AppRoutes;
